(function ($) {
    $(document).ready(function () {
        if ($('.tabs-with-content').length > 0) {


            $('.tabs-with-content').each(function () {
                $('.tabs-with-content .col-two:last-of-type').addClass("content-box");
                if($('.tabs-with-content .views-element-container').length>0) {
                    $(this).find(".content-box div[class^='js-view-dom-id'] >div:first-of-type ").addClass('show');
                    $(this).find(".tabs-wrapper div[class^='js-view-dom-id'] >div:first-of-type .tab-item").addClass("selected");
                    $(this).find(".content-box div[class^='js-view-dom-id'] >div:first-of-type .tab-content").fadeIn().css("display", "flex");

                    $(this).find(".tab-item h5").click(function (e) {
                        //e.preventDefault();
                        var index = $(this).parent().parent().index();
                        $(this).parents('.tabs-with-content').find(".col-two.content-box div[class^='js-view-dom-id'] >div").eq(index).addClass('show');
                        $(this).parents('.tabs-with-content').find(".col-two.content-box div[class^='js-view-dom-id'] >div").eq(index).siblings().removeClass('show');
                        $(this).parents('.tabs-with-content').find(".col-two.content-box div[class^='js-view-dom-id'] >div").eq(index).find('.tab-content').fadeIn().css("display", "flex");
                        $(this).parents('.tabs-with-content').find(".col-two.content-box div[class^='js-view-dom-id'] >div").eq(index).siblings().find('.tab-content').css("display", "none");
                        $(this).parent().addClass("selected");
                        $(this).parent().parent().siblings().find('.tab-item').removeClass("selected");
                    });

                }
                else {
                    $(this).find(".tab-item:first-of-type").addClass("selected");
                    $(this).find(".tab-content:first-of-type").fadeIn().css("display", "flex");

                $(this).find(".tab-item h5").click(function (e) {
                    //e.preventDefault();
                    var index = $(this).parent().index();
                    $(this).parents('.tabs-with-content').find(".col-two.content-box .tab-content").eq(index).fadeIn().css("display", "flex");
                    $(this).parents('.tabs-with-content').find(".col-two.content-box .tab-content").eq(index).siblings().css("display", "none");
                    $(this).parent().addClass("selected").siblings().removeClass("selected");
                });

                }
                $(this).find(".tab-item h5").mouseenter(function (e) {
                    //e.preventDefault();
                    $(this).trigger("click");
                });
            });

            $(".tabs-with-content .tab-content").each(function (i) {
                var content =  $(this).clone();
                $(".tabs-with-content .tab-item").each(function (j) {
                    if(i == j){
                        $('<div/>')
                            .attr( { class: "mobile-option" } ).html(content)
                            .appendTo($(this).find("h5"));
                    }
                })
            });

        }

    });
})(jQuery);


